<template>
  <div id="main" style="opacity: 1;">
    <!-- header -->
    <app-header/>
    <!-- header end  -->
    <!-- wrapper  -->
    <div id="wrapper">
      <!-- content -->
      <div class="content">
        <!--  section  -->
        <Hero/>
        <!--  section  end-->
        <!-- breadcrumbs-->
        <!-- breadcrumbs end -->
        <!-- section -->
        <!-- section end-->
        <!-- section -->
        <section>
          <div class="container">
            <!--about-wrap -->
            <div class="about-wrap">
              <div class="row">
                <div class="col-md-5">
                  <div class="about-title ab-hero fl-wrap">
                    <h2>Why Choose Kodi Kenya? </h2>
                    <h4>
                      We strive to make sure that all properties added are genuine and the owners are duly
                      verified.
                    </h4>
                  </div>
                  <div class="services-opions fl-wrap">
                    <ul>
                      <li>
                        <i class="fal fa-headset"></i>
                        <h4>24 Hours Support </h4>
                        <p>
                          Whether you are a landlord, a tenant, a property manager or an agency, we avail to you a 24
                          hour support to ensure smooth continuity of your business.
                        </p>
                      </li>
                      <li>
                        <i class="fal fa-users-cog"></i>
                        <h4>
                          Tenant Support Module
                        </h4>
                        <p>
                          Pay for your rent easily through our Bank & Mobile Money providers. Raise tickets and have
                          them resolved right from the app without any hassle.
                        </p>
                      </li>
                      <li>
                        <i class="fal fa-phone-laptop"></i>
                        <h4>Agents & Landlords</h4>
                        <p>Manage your properties with ease through our comprehensive property management dashboard.
                          Send bulk communication to your tenants with our integrated chat system.</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-6">
                  <div class="about-img fl-wrap">
<!--                    <images src="../../assets/images/ceo/living.jpeg" class="respimg" alt="">-->
                    <div class="about-img-hotifer color-bg">
                      <p>
                        Welcome to Kodi Kenya We provide the best Tool for managing your properties. Whether you're a
                        landlord one property, or an agency managing multiple properties, our software assists you to
                        streamline operations, maximize efficiency, and elevate tenant satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- about-wrap end  -->
          </div>
        </section>
        <!-- section end-->
        <!--section end-->
        <!-- section -->

        <!-- section end-->
        <!-- section -->
        <section class="color-bg small-padding">
          <div class="container">
            <div class="main-facts fl-wrap">
              <!-- inline-facts  -->
              <div class="inline-facts-wrap">
                <div class="inline-facts">
                  <div class="milestone-counter">
                    <div class="stats animaper">
                      <div class="num" data-content="0" data-num="578">1000+</div>
                    </div>
                  </div>
                  <h6>Agents and Agencies</h6>
                </div>
              </div>
              <!-- inline-facts end -->
              <!-- inline-facts  -->
              <div class="inline-facts-wrap">
                <div class="inline-facts">
                  <div class="milestone-counter">
                    <div class="stats animaper">
                      <div class="num" data-content="0" data-num="5000">5000+</div>
                    </div>
                  </div>
                  <h6>Properties Managed</h6>
                </div>
              </div>
              <!-- inline-facts end -->
              <!-- inline-facts  -->
              <div class="inline-facts-wrap">
                <div class="inline-facts">
                  <div class="milestone-counter">
                    <div class="stats animaper">
                      <div class="num" data-content="0" data-num="200">200+</div>
                    </div>
                  </div>
                  <h6>Landlords</h6>
                </div>
              </div>
              <!-- inline-facts end -->
              <!-- inline-facts  -->
              <div class="inline-facts-wrap">
                <div class="inline-facts">
                  <div class="milestone-counter">
                    <div class="stats animaper">
                      <div class="num" data-content="0" data-num="1000000">1,000,000+</div>
                    </div>
                  </div>
                  <h6>In Rent Collected</h6>
                </div>
              </div>
              <!-- inline-facts end -->
            </div>
          </div>
        </section>
        <!-- section end-->
        <!-- section -->
        <Testimonials/>
        <!-- section end-->
      </div>
      <!-- content end -->
      <!-- subscribe-wrap -->
      <div class="subscribe-wrap fl-wrap">
        <div class="container">
          <div class="subscribe-container fl-wrap color-bg">
            <div class="pwh_bg"></div>
            <div class="mrb_dec mrb_dec3"></div>
            <div class="row">
              <div class="col-md-6">
                <div class="subscribe-header">
                  <h4>newsletter</h4>
                  <h3>Sign up for newsletter and get latest news and update</h3>
                </div>
              </div>
              <div class="col-md-1"></div>
              <div class="col-md-5">
                <div class="footer-widget fl-wrap">
                  <div class="subscribe-widget fl-wrap">
                    <div class="subcribe-form">
                      <form id="subscribe">
                        <input class="enteremail fl-wrap" name="email" id="subscribe-email"
                               placeholder="Enter Your Email" spellcheck="false" type="text">
                        <button type="submit" id="subscribe-button"
                                class="subscribe-button color-bg"> Subscribe
                        </button>
                        <label for="subscribe-email" class="subscribe-message"></label>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- subscribe-wrap end -->
      <!-- footer -->
      <footer-component/>
      <!-- footer end -->
    </div>
    <!-- wrapper end -->
    <!--register form -->

    <!--register form end -->
    <!--secondary-nav -->
    <div class="secondary-nav">
      <ul>
        <li><a href="dashboard-add-listing.html" class="tolt" data-microtip-position="left"
               data-tooltip="Sell Property"><i class="fal fa-truck-couch"></i> </a></li>
        <li><a href="listing.html" class="tolt" data-microtip-position="left" data-tooltip="Buy Property"> <i
            class="fal fa-shopping-bag"></i></a></li>
        <li><a href="compare.html" class="tolt" data-microtip-position="left" data-tooltip="Your Compare"><i
            class="fal fa-exchange"></i></a></li>
      </ul>
      <div class="progress-indicator">
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="-1 -1 34 34">
          <circle cx="16" cy="16" r="15.9155"
                  class="progress-bar__background"/>
          <circle cx="16" cy="16" r="15.9155"
                  class="progress-bar__progress
                            js-progress-bar"/>
        </svg>
      </div>
    </div>
    <!--secondary-nav end -->
    <a class="to-top color-bg"><i class="fas fa-caret-up"></i></a>
    <!--map-modal -->
    <div class="map-modal-wrap">
      <div class="map-modal-wrap-overlay"></div>
      <div class="map-modal-item">
        <div class="map-modal-container fl-wrap">
          <h3><span>Listing Title </span></h3>
          <div class="map-modal-close"><i class="far fa-times"></i></div>
          <div class="map-modal fl-wrap">
            <div id="singleMap" data-latitude="40.7" data-longitude="-73.1"></div>
            <div class="scrollContorl"></div>
          </div>
        </div>
      </div>
    </div>
    <!--map-modal end -->
  </div>
</template>
<script>
import AppHeader from '../../components/Sections/Header'
import Hero from "@/components/Sections/Hero";
import {mapActions, mapGetters} from "vuex";
import FooterComponent from "@/components/Sections/Footer";
import Testimonials from "@/components/Shared/Testimonials";

export default {
  components: {
    Testimonials,
    FooterComponent,
    AppHeader,
    Hero,
  },
  data() {
    return {
      filters: {},
      active_index: -1
    }
  },
  computed: {
    ...mapGetters({
      'property_statuses': 'property_statuses/property_statuses'
    })
  },
  methods: {
    ...mapActions({
      'getPropertyStatuses': "property_statuses/getPropertyStatuses"
    }),
    filterProperty(status_id, index) {
      this.active_index = index
      this.filters.property_status_id = status_id === 'all' ? {} : [status_id]
    },
    getActiveClass(index) {
      return index === this.active_index ? 'gallery-filter gallery-filter-active' : 'gallery-filter'
    }
  },
  created() {
    this.getPropertyStatuses({})
  }
}
</script>
